import { render, staticRenderFns } from "./ChunkUploadAWS.vue?vue&type=template&id=60ff1b53"
import script from "./ChunkUploadAWS.vue?vue&type=script&lang=js"
export * from "./ChunkUploadAWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports